import React, { useState } from "react";
import bg_image_1 from "../../assets/images/bg-img-home.png";
import bg_image_2 from "../../assets/images/bg-img-home1.png";
import bg_image_3 from "../../assets/images/img-bg-section.png";
import bg_image_4 from "../../assets/images/Home-bg-section.jpg";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
const HomePageForm = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    phone: "",
    email: "",
    date: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const validateForm = () => {
    let tempErrors = {};
    if (!formData.fullname.trim())
      tempErrors.fullname = "Full name is required";
    if (!formData.phone.trim()) tempErrors.phone = "Phone number is required";
    if (!/^\d{10}$/.test(formData.phone))
      tempErrors.phone = "Phone must be 10 digits";
    if (!formData.email.trim()) tempErrors.email = "Email is required";
    if (!/\S+@\S+\.\S+/.test(formData.email))
      tempErrors.email = "Invalid email";
    if (!formData.date.trim()) tempErrors.date = "Date is required";
    if (!formData.message.trim()) tempErrors.message = "Message is required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("✅ Form submitted:", formData);
      // You can reset here if needed
    } else {
      console.warn("🚫 Validation failed");
    }
  };
  return (
    <div className="w-full  relative xl:h-[900px] h-[850px] flex flex-row overflow-hidden bg-[#0F2349]">
      <div className="absolute top-0 left-0">
        <img
          loading="lazy"
          width="130"
          height="100"
          src={bg_image_1}
          alt="bg-image"
        />
      </div>
      <div className="absolute md:block hidden bottom-0 right-0">
        <img
          loading="lazy"
          width="330"
          height="180"
          src={bg_image_2}
          alt="bg-image"
        />
      </div>
      <div className="absolute md:block hidden bottom-0 left-0">
        <img
          loading="lazy"
          width=""
          height=""
          src={bg_image_3}
          alt="bg-image"
        />
      </div>
      <div className="md:w-1/2 md:block hidden ">
        <div className="w-full relative flex px-2 pb-40 md:pb-80">
          <div className="md:py-16 py-8 px-14 md:w-[655px] w-auto  absolute xl:-right-36 lg:-right-60 md:-right-72 top-1/2 transform  bg-[#243FFA] rounded-lg">
            <div className="text-[16px] font-normal text-white font-outfit my-2">
              REQUEST A CONSULTATION
            </div>
            <h2 className="md:text-[52px] text-3xl font-semibold font-outfit text-white">
              Make an Appointent
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="w-full flex sm:flex-row flex-col gap-2 my-2">
                <div className="sm:w-1/2 w-full p-2">
                  <input
                    type="text"
                    name="fullname" aria-label="Your name"
                    value={formData.fullname}
                    onChange={handleChange}
                    className="w-full border-b-[1px]  border-[#d4dffb] px-1 bg-transparent outline-none py-2 placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit"
                    placeholder="Full Name"
                  />
                  {errors.fullname && (
                    <p className="text-[#ff0b0b] text-sm">{errors.fullname}</p>
                  )}
                </div>
                <div className="sm:w-1/2 w-full p-2">
                  <input
                    type="text"
                    name="phone" aria-label="Your phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full border-b-[1px]  border-[#d4dffb] outline-none py-2 px-1 bg-transparent placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit"
                    placeholder="Phone No:"
                  />
                  {errors.phone && (
                    <p className="text-[#ff0808] text-sm">{errors.phone}</p>
                  )}
                </div>
              </div>
              <div className="w-full flex sm:flex-row flex-col gap-2 my-2">
                <div className="sm:w-1/2 w-full p-2">
                  <input
                    type="email" aria-label="Your email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border-b-[1px] border-[#d4dffb] outline-none py-2 px-1 bg-transparent placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit"
                    placeholder="Email"
                  />
                  {errors.email && (
                    <p className="text-[#ff2b2b] text-sm">{errors.email}</p>
                  )}
                </div>
                <div className="sm:w-1/2 w-full p-2">
                  <input
                    type="date"
                    name="date" aria-label="Your date"
                    value={formData.date}
                    onChange={handleChange}
                    className="w-full border-b-[1px] border-[#d4dffb] outline-none py-2 px-1 bg-transparent placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit appearance-none relative z-10 custom-date"
                  />
                  {errors.date && (
                    <p className="text-[#ff2b2b] text-sm">{errors.date}</p>
                  )}
                </div>
              </div>
              <div className="my-2 p-2">
                <textarea
                  name="message"
                  rows={4}
                  cols={3} aria-label="Your message"
                  value={formData.message}
                  onChange={handleChange}
                  resize="false"
                  placeholder="Message"
                  className="w-full border-b-[1px] resize-none border-[#d4dffb] outline-none py-2 px-1 bg-transparent placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit"
                />
                {errors.message && (
                  <p className="text-[#ff0808] text-sm">{errors.message}</p>
                )}
              </div>
              <button type="submit" className="my-8 border-none outline-none ">
                <p className="text-white font-outfit text-xl hover:text-black flex justify-start font-bold items-center group ">
                  Book An Appointment{" "}
                  <span className="text-sm ml-6 group-hover:bg-white border-[1px] border-white rounded-full p-5  flex justify-center items-center  w-12 h-12  text-white transition-all hover:duration-200 group-hover:text-black">
                    <ArrowOutwardIcon className="text-sm" />
                  </span>
                </p>
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="w-full md:hidden  block pt-24 mb-20 px-4">
        <div className="w-full relative flex justify-center items-center ">
          <div className=" py-8 px-14  w-auto bg-[#243FFA] rounded-lg">
            <div className="text-[16px] font-normal text-white font-outfit">
              REQUEST A CONSULTATION
            </div>
            <h2 className="md:text-[52px] text-3xl font-semibold font-outfit text-white">
              Make an Appointent
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="w-full flex sm:flex-row flex-col gap-2 my-2">
                <div className="sm:w-1/2 w-full p-2">
                  <input
                    type="text"
                    name="fullname" aria-label="Your Name"
                    className="w-full border-b-[1px]  border-[#d4dffb] px-1 bg-transparent outline-none py-2 placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit"
                    placeholder="Full Name"
                    value={formData.fullname}
                    onChange={handleChange}
                  />
                  {errors.fullname && (
                    <p className="text-[#ff0b0b] text-sm">{errors.fullname}</p>
                  )}
                </div>
                <div className="sm:w-1/2 w-full p-2">
                  <input
                    type="text"
                    value={formData.phone}
                    onChange={handleChange} aria-label="Your phone"
                    name="phone"
                    className="w-full border-b-[1px]  border-[#d4dffb] outline-none py-2 px-1 bg-transparent placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit"
                    placeholder="Phone No:"
                  />{" "}
                  {errors.phone && (
                    <p className="text-[#ff0808] text-sm">{errors.phone}</p>
                  )}
                </div>
              </div>
              <div className="w-full flex sm:flex-row flex-col gap-2 my-2">
                <div className="sm:w-1/2 w-full p-2">
                  <input
                    type="email"
                    name="email" aria-label="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border-b-[1px] border-[#d4dffb] outline-none py-2 px-1 bg-transparent placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit"
                    placeholder="Email"
                  />{" "}
                  {errors.email && (
                    <p className="text-[#ff2b2b] text-sm">{errors.email}</p>
                  )}
                </div>
                <div className="sm:w-1/2 w-full p-2">
                  <input
                    type="date"
                    name="date"  aria-label="date"
                    value={formData.date}
                    onChange={handleChange}
                    className="w-full border-b-[1px] border-[#d4dffb] outline-none py-2 px-1 bg-transparent placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit appearance-none relative z-10 custom-date"
                  />{" "}
                  {errors.date && (
                    <p className="text-[#ff2b2b] text-sm">{errors.date}</p>
                  )}
                </div>
              </div>
              <div className="my-2 p-2 ">
                <textarea
                  name="message"
                  rows={4} aria-label="Your message"
                  cols={3}
                  value={formData.message}
                  onChange={handleChange}
                  resize="false"
                  placeholder="Message"
                  className="w-full border-b-[1px] resize-none border-[#d4dffb] outline-none py-2 px-2 bg-transparent placeholder:text-[#d4dffb] text-[#d4dffb] font-outfit"
                />{" "}
                {errors.message && (
                  <p className="text-[#ff0808] text-sm">{errors.message}</p>
                )}
              </div>
              <button type="submit" className="my-8 border-none outline-none ">
                <p className="text-white font-outfit text-xl hover:text-black flex justify-start font-bold items-center group ">
                  Book An Appointment{" "}
                  <span className="text-sm ml-6 group-hover:bg-white border-[1px] border-white rounded-full p-5  flex justify-center items-center  w-12 h-12  text-white transition-all hover:duration-200 group-hover:text-black">
                    <ArrowOutwardIcon className="text-sm" />
                  </span>
                </p>
              </button>
            </form>
          </div>
        </div>
      </div>
      <div
        className="md:w-1/2 md:block hidden"
        style={{
          backgroundImage: `url(${bg_image_4})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
    </div>
  );
};

export default HomePageForm;
